export function canShareDiagnosticsHeap(): boolean {
  return false;
}

export async function shareDiagnosticsHeap(): Promise<void> {
  throw new Error("Use the browser developer tools to capture a JavaScript heap snapshot.");
}
